import { weappSDK } from "../sdk";
import { regReactPlugin, Options } from './index';

const reg = /\$(user|department)Name=(.*?)\$/g;

const replaceHTML = (m: string, type: string, openid: string) => `<ww-open-data type="${type}Name" openid="${openid}"></ww-open-data>`

let timer: any = null;
let timestamp = Date.now();

function batchUpdate() {
  timestamp = Date.now();
  if (!timer) {
    timer = setInterval(() => {
      weappSDK && weappSDK.customSDK && weappSDK.exec('convertWWOpenData', {
        tenantKey: window.TEAMS?.currentTenant?.tenantKey
      });
      if (Date.now() - timestamp > 1000) {
        clearInterval(timer);
        timer = null;
      }
    }, 300);
  }
}

function convert(o: Options, key: string) {
  if (typeof o[key] === 'string') {
    if (reg.test(o[key])) {
      const node = document.createElement('span');
      const innerHTML = o[key].replace(reg, replaceHTML)
      if (key !== 'html') {
        node.innerHTML = innerHTML;
        o[key] = node;
      } else {
        o[key] = innerHTML;
      }
      batchUpdate();
    }
  }
  return o;
}

export function convertWWOpenData() {
  regReactPlugin('setNodeValue', (o) => convert(o, 'newText'));
  regReactPlugin('setTextContent', (o) => convert(o, 'text'));
  regReactPlugin('createTextInstance', (o) => convert(o, 'text'));
  regReactPlugin('setInnerHTML', (o) => convert(o, 'html'));
  regReactPlugin('setAttribute', (o) => {
    if (o.propertyName === 'title' || o.attributeName === 'title') {
      if (reg.test(o.attributeValue)) {
        if (typeof window.weappUi?.Popover?.create === 'function') {
          const innerHTML = o.attributeValue.replace(reg, replaceHTML)
          window.weappUi?.Popover?.create({
            element: o.node,
            popoverType: 'tooltip',
            placement: 'top',
            popup: <span dangerouslySetInnerHTML={{ __html: innerHTML }} />,
            onVisibleChange: () => {
              batchUpdate()
            }
          })
        }
        o.attributeValue = '';
      }
    }
    return o;
  })
}